var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the associative array value for `key`.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function assocGet(array, key) {
  var index = assocIndexOf(array, key);
  return index < 0 ? undefined : array[index][1];
}

module.exports = assocGet;



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/_assocGet.js
 ** module id = 52
 ** module chunks = 2 3 4 8 9 10 12 13 14
 **/